import * as React from 'react';
import CTSAReportHeader from "./CTSAReportHeader";
import CompareGroupSelector from "./CompareGroupSelector";
import { generateSankeyData, transformTotals } from "./CTSAReportHelper";
import AlluvialChart from "./AlluvialChart";



interface Props {
    comparisonGroup?: string[];
    availableGroup?: string[];
    changeComparisonGroup?();
    displayId?: string;
    CTSASchoolList?: {}[];
    careerData?: {}[];
    awardTotal?: { KL2: number, K01: number, K08: number, K12: number, K23: number }
    awardPathway?: {}[];
    //kl2ModalPathway?: {pathway}[];
    kl2ModalPathway?: any;
}




class FundingSequence extends React.Component<Props, {}> {
    render() {

        const { awardTotal, awardPathway, comparisonGroup, changeComparisonGroup, displayId, CTSASchoolList, availableGroup, kl2ModalPathway } = this.props;
        if (awardTotal && awardPathway && comparisonGroup && kl2ModalPathway) {
            return (
                <div className="tabcontents container-fluid" style={{ border: 'none' }}>

                    <CTSAReportHeader compareGroup={comparisonGroup} displayId={displayId} CTSASchoolList={CTSASchoolList} awardTotal={transformTotals(awardTotal)} />
                    <CompareGroupSelector
                        onChange={changeComparisonGroup}
                        selectedGroup={comparisonGroup}
                        awardTotal={ transformTotals(awardTotal)}
                        availableGroup={availableGroup}
                    />
                    <AlluvialChart sankeyData={generateSankeyData(awardPathway, comparisonGroup)} kl2ModalPathway={kl2ModalPathway} comparisonGroup={comparisonGroup} />        
                    <img src={require('./CTSA_logo.jpg')} height='50px' style={{ marginTop: '20px' }} />
                </div>


            );


        } else {
            return <i className="fa fa-spinner"></i>;
        }

    }
}
export default FundingSequence;




